<template>
	<vue-final-modal v-slot="{ params, close }" v-bind="$attrs">
		<div class="modalWrapper profile" style="opacity: 1; align-items: center; justify-content: center; display: flex; width: 100%; height: 100%;">
			<div class="modal profile" style="top: 0;">
				<div class="modalContent">
					<div class="modalDecoration"></div>
					<div class="functionPanel unselectable">
						<a class="closeWindow clickable" @click="onModalClose(close)">
							<div class="decoration" content="Закрыть" v-tippy="{placement: 'bottom'}">
								<i class="action_cancel_tiny_flat_black"></i>
							</div>
						</a>
					</div>
					<div>
						<div class="contentHeader unselectable">
							<h2 ng-bind="w.playerData.name" class=" msAntiScroll" draggable="true">Migera</h2>
						</div>
					</div>
					<div class="heightTransitionContent">
						<div class="contentTabulation">
							<div class="tabulationContent scrollable">
								<div class="scrollContentOuterWrapper">
									<div class="scrollContent">
										<div class="scrollContentInnerWrapper" style="width: auto;">
											<div ng-transclude="">
												<div class="profileWindow" ng-controller="profileWindowCtrl">
													<div ng-repeat="tab in tabData.loadedTabs" ng-if="tab" class="loadedTab tabplayerProfile activeTab currentTab" ng-class="{currentTab: tab == tabData.currentTab, hiddenTab: tab != tabData.currentTab, activeTab: tab == tabData.activeTab, hiddenDynamicHeight: tab != tabData.activeTab}" ng-include="tabData.bodyTemplatePrefix + tab + tabData.bodyTemplateSuffix">
														<div ng-controller="playerProfileCtrl" class="playerProfile">
															<div class="player-profile" playerid="662">
																<div class="playerProfile">
																	<div class="detailsWrapper">
																		<div class="contentBox gradient">
																			<div class="flagHanger  king" ng-if="!kingdomProfile">
																				<div class="flag"></div>
																				<i class="community_king_small_flat_black"></i>
																			</div>
																			<div class="contentBoxHeader headerWithArrowEndings kingdomRole kingdomRole kingdomRole1">
																				<div class="content" ng-if="!kingdomProfile">Migera</div>
																				<!-- ngIf: kingdomProfile -->
																			</div>
																			<div class="contentBoxBody">
																				<div class="playerDetails">
																					<div class="contentBox transparent">
																						<div class="contentBoxHeader">
																							<div ng-if="!kingdomProfile" translate="" options="1"><span>Король</span></div>
																							<!-- ngIf: kingdomProfile -->
																							<i ng-if="::playerInfo.language" class="languageFlag ru" content="ru" v-tippy="{placement: 'bottom'}"></i>
																						</div>
																						<div class="contentBoxBody">
																							<div>
																								<span class="desc" translate=""><span>Ранг</span></span>
																								<span class="data">17</span>
																							</div>
																							<div>
																								<span class="desc" translate=""><span>Население</span></span>
																								<span class="data">10633</span>
																							</div>
																							<div>
																								<span class="desc" translate=""><span>Деревни</span></span>
																								<span class="data">9</span>
																							</div>
																							<div ng-if="!kingdomProfile">
																								<span class="desc" translate=""><span>Королевство</span></span>
																									<span class="data">
																										<!-- ngIf: playerData.kingdomId == 0 -->
																										<a ng-class="{disabled: kingdomId <= 0 || nolink}" class="kingdomLink truncated clickable" clickable="$root.openWindow('kingdom', {'kingdomId': 3}, null, true)" ng-if="playerData.kingdomId > 0" kingdomid="3">MИР</a>
																									</span>
																							</div>
																							<div>
																								<span class="desc" translate=""><span>Народ</span></span>
																								<span class="data" translate="" options="3"><span>Галлы</span></span>
																							</div>
																						</div>
																					</div>
																				</div>
																				<div class="playerProfileAvatar kingdomRole1">
																					<div class="avatarLink clickable" clickable="kingdomProfile ? openWindow('profile', {'playerId': 662 }, null, true) : openOverlay('playerProfileFullImage', {'playerId': 662 });">
																						<avatar-image scale="0.55" class="avatarImage" player-id="662" size="big" avatar-class="profileImage">
																							<div class="heroImage  profileImage female" ng-class="::class" rerender="rerender">
																								<!-- ngIf: playerId == robberId -->
																								<!-- ngIf: playerId == npcGovernorId -->
																								<canvas width="192" height="192"></canvas>
																							</div>
																						</avatar-image>
																						<div class="prestigeStars" ng-if="config.balancing.features.prestige">
																							<div class="innerStars" stars="playerData.stars" size="tiny">
																								<!-- ngIf: !badge -->
																								<i ng-if="badge" class="prestigeBadge prestige_silverBadge_tiny_illu"></i>
																							</div>
																						</div>
																					</div>

																					<span class="decoration"></span>
																					<!-- ngIf: myPlayerId == playerId && config.balancing.features.prestige -->
																					<div ng-if="myPlayerId != playerId && config.balancing.features.prestige" class="prestigeStarsTooltip" content="Уровень престижа показывает опыт игрока. Престиж можно заработать за выполнение еженедельных задач и достижений." v-tippy="{placement: 'bottom'}" tooltip-translate="Prestige.Stars.Tooltip.Other"></div>
																				</div>
																				<div class="kingdomDetails">
																					<div class="background profile_kingdomBackground_layout"></div>
																					<div class="contentBox transparent">
																						<div class="contentBoxHeader">
																							<span class="data" ng-if="playerData.kingdomId > 0" translate=""><span>Королевство</span></span>
																							<span class="data" ng-if="playerData.kingdomId == 0" translate=""><span>Без королевства</span></span>
																						</div>
																						<div class="contentBoxBody empty" ng-if="playerData.kingdomId <= 0">
																						</div>
																						<div class="contentBoxBody" ng-if="playerData.kingdomId > 0">
																							<div ng-if="playerData.kingdomRole != ROLE_KING">
																								<span class="desc" translate=""><span>Король</span></span>
																								<span class="data"><a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="1111" playername="">Хоттабыч</a></span>
																							</div>
																							<div>
																								<span class="desc" translate=""><span>Ранг</span></span>
																								<span class="data" ng-if="kingdomStats.rank >= 0">2</span>
																								<!-- ngIf: kingdomStats.rank === false -->
																							</div>
																							<div>
																								<span class="desc" translate=""><span>Победные очки</span></span>
																								<span class="data" ng-if="kingdomStats.victoryPoints > 0">7 001 151</span>
																								<!-- ngIf: kingdomStats.victoryPoints === false -->
																							</div>
																							<div>
																								<span class="desc" translate=""><span>Сокровища</span></span>
																								<span class="data" ng-if="kingdomStats.treasures">146 750</span>
																								<!-- ngIf: !kingdomStats.treasures -->
																							</div>
																							<div ng-if="kingdomStats.memberLimit <= 0 || playerData.kingdomRole == ROLE_KING">
																								<span class="desc" translate=""><span>Срок (дни)</span></span>
																								<span class="data">19</span>
																							</div>
																							<div ng-if="kingdomStats.memberLimit > 0" tooltip="" tooltip-show="player.data.kingdomId == playerData.kingdomId" tooltip-url="tpl/society/partials/kingdom/membersTooltip.html">
																								<span class="desc" translate=""><span>Участники</span></span>
																								<span class="data">43/100</span>
																							</div>
																						</div>
																					</div>
																				</div>
																			</div>
																		</div>
																	</div>
																	<!-- ngIf: kingdomProfile -->
																</div>
															</div>
															<div class="infoWrapper">
																<div class="playerVillages">
																	<div class="scrollContentOuterWrapper" style="width: 298px;">
																		<div class="scrollContent" dynamic-height="false" style="width: 298px; overflow-y: hidden;">
																			<div class="scrollContentInnerWrapper" ng-transclude="" style="width: auto;">
																				<table class="fixedTableHeader scrollable" scrollable="">
																					<thead>
																						<tr>
																							<th class="name">
																								<i content="Деревни" v-tippy="{placement: 'bottom'}" tooltip-translate="Villages" class="village_village_small_flat_black"></i> (9)
																							</th>
																							<th class="coordinates"><i class="symbol_target_small_flat_black"></i></th>
																							<th class="population">
																								<i content="Население" v-tippy="{placement: 'bottom'}" tooltip-translate="Population" class="unit_population_small_flat_black"></i>
																							</th>
																						</tr>
																					</thead>
																					<tbody>
																						<tr ng-repeat="village in playerData.villages | orderBy:'population':true">
																							<td class="name">
																								<a ng-class="{disabled: villId <= 2 || nolink}" class="villageLink truncated clickable" clickable="$root.openWindow('mapCellDetails', {'cellId': 536625151}, null, true)" village-link="" villageid="536625151" villagename="Basidio">Basidio</a>
																								<i ng-if="village.isMainVillage" class="village_main_small_flat_black" content="Столица" v-tippy="{placement: 'bottom'}" tooltip-translate="Village.main"></i>
																							</td>
																							<td class="coordinates">
																								<span class="coordinateWrapper" coordinates="" aligned="true" x="-1" y="-8">
																									<a ng-if="hasLink" clickable="$root.openPage('map', 'centerId', '536625151_1728243293.4');" class="clickable">
																										<span class="coordinates coordinatesWrapper  coordinatesAligned" ng-bind-html=" coord | bidiCoordinate:x:y "><span class="coordinateX">(-1</span><span class="coordinatePipe">|</span><span class="coordinateY">-8)</span></span>
																									</a>
																									<!-- ngIf: !hasLink -->
																								</span>
																							</td>
																							<td class="population">1689</td>
																						</tr>
																						<tr ng-repeat="village in playerData.villages | orderBy:'population':true">
																							<td class="name">
																								<a ng-class="{disabled: villId <= 2 || nolink}" class="villageLink truncated clickable" clickable="$root.openWindow('mapCellDetails', {'cellId': 536821755}, null, true)" village-link="" villageid="536821755" villagename="DeLorean">DeLorean</a>
																								<!-- ngIf: village.isMainVillage -->
																							</td>
																							<td class="coordinates">
																								<span class="coordinateWrapper" coordinates="" aligned="true" x="-5" y="-2">
																									<a ng-if="hasLink" clickable="$root.openPage('map', 'centerId', '536821755_1728243293.4');" class="clickable">
																										<span class="coordinates coordinatesWrapper  coordinatesAligned" ng-bind-html=" coord | bidiCoordinate:x:y "><span class="coordinateX">(-5</span><span class="coordinatePipe">|</span><span class="coordinateY">-2)</span></span>
																									</a>
																									<!-- ngIf: !hasLink -->
																								</span>
																							</td>
																							<td class="population">1677</td>
																						</tr>
																						<tr ng-repeat="village in playerData.villages | orderBy:'population':true">
																							<td class="name">
																								<a ng-class="{disabled: villId <= 2 || nolink}" class="villageLink truncated clickable" clickable="$root.openWindow('mapCellDetails', {'cellId': 536625142}, null, true)" village-link="" villageid="536625142" villagename="INEOS Grenadier">INEOS Grenadier</a>
																								<!-- ngIf: village.isMainVillage -->
																							</td>
																							<td class="coordinates">
																								<span class="coordinateWrapper" coordinates="" aligned="true" x="-10" y="-8">
																									<a ng-if="hasLink" clickable="$root.openPage('map', 'centerId', '536625142_1728243293.4');" class="clickable">
																										<span class="coordinates coordinatesWrapper  coordinatesAligned" ng-bind-html=" coord | bidiCoordinate:x:y "><span class="coordinateX">(-10</span><span class="coordinatePipe">|</span><span class="coordinateY">-8)</span></span>
																									</a>
																									<!-- ngIf: !hasLink -->
																								</span>
																							</td>
																							<td class="population">1394</td>
																						</tr>
																						<tr ng-repeat="village in playerData.villages | orderBy:'population':true">
																							<td class="name">
																								<a ng-class="{disabled: villId <= 2 || nolink}" class="villageLink truncated clickable" clickable="$root.openWindow('mapCellDetails', {'cellId': 537182213}, null, true)" village-link="" villageid="537182213" villagename="Asco">Asco</a>
																								<!-- ngIf: village.isMainVillage -->
																							</td>
																							<td class="coordinates">
																								<span class="coordinateWrapper" coordinates="" aligned="true" x="5" y="9">
																									<a ng-if="hasLink" clickable="$root.openPage('map', 'centerId', '537182213_1728243293.4');" class="clickable">
																										<span class="coordinates coordinatesWrapper  coordinatesAligned" ng-bind-html=" coord | bidiCoordinate:x:y "><span class="coordinateX">(5</span><span class="coordinatePipe">|</span><span class="coordinateY">9)</span></span>
																									</a>
																									<!-- ngIf: !hasLink -->
																								</span>
																							</td>
																							<td class="population">1270</td>
																						</tr>
																						<tr ng-repeat="village in playerData.villages | orderBy:'population':true">
																							<td class="name">
																								<a ng-class="{disabled: villId <= 2 || nolink}" class="villageLink truncated clickable" clickable="$root.openWindow('mapCellDetails', {'cellId': 536887296}, null, true)" village-link="" villageid="536887296" villagename="Чудо-Юдо Рыба Кит">Чудо-Юдо Рыба Кит</a>
																								<!-- ngIf: village.isMainVillage -->
																							</td>
																							<td class="coordinates">
																								<span class="coordinateWrapper" coordinates="" aligned="true" x="0" y="0">
																									<a ng-if="hasLink" clickable="$root.openPage('map', 'centerId', '536887296_1728243293.4');" class="clickable">
																										<span class="coordinates coordinatesWrapper  coordinatesAligned" ng-bind-html=" coord | bidiCoordinate:x:y "><span class="coordinateX">(0</span><span class="coordinatePipe">|</span><span class="coordinateY">0)</span></span>
																									</a>
																									<!-- ngIf: !hasLink -->
																								</span>
																							</td>
																							<td class="population">1231</td>
																						</tr>
																						<tr ng-repeat="village in playerData.villages | orderBy:'population':true">
																							<td class="name">
																								<a ng-class="{disabled: villId <= 2 || nolink}" class="villageLink truncated clickable" clickable="$root.openWindow('mapCellDetails', {'cellId': 535412758}, null, true)" village-link="" villageid="535412758" villagename="Чудилка">Чудилка</a>
																								<!-- ngIf: village.isMainVillage -->
																							</td>
																							<td class="coordinates">
																								<span class="coordinateWrapper" coordinates="" aligned="true" x="22" y="-45">
																									<a ng-if="hasLink" clickable="$root.openPage('map', 'centerId', '535412758_1728243293.4');" class="clickable">
																										<span class="coordinates coordinatesWrapper  coordinatesAligned" ng-bind-html=" coord | bidiCoordinate:x:y "><span class="coordinateX">(22</span><span class="coordinatePipe">|</span><span class="coordinateY">-45)</span></span>
																									</a>
																									<!-- ngIf: !hasLink -->
																								</span>
																							</td>
																							<td class="population">1100</td>
																						</tr>
																						<tr ng-repeat="village in playerData.villages | orderBy:'population':true">
																							<td class="name">
																								<a ng-class="{disabled: villId <= 2 || nolink}" class="villageLink truncated clickable" clickable="$root.openWindow('mapCellDetails', {'cellId': 535379951}, null, true)" village-link="" villageid="535379951" villagename="Elfin">Elfin</a>
																								<!-- ngIf: village.isMainVillage -->
																							</td>
																							<td class="coordinates">
																								<span class="coordinateWrapper" coordinates="" aligned="true" x="-17" y="-46">
																									<a ng-if="hasLink" clickable="$root.openPage('map', 'centerId', '535379951_1728243293.4');" class="clickable">
																										<span class="coordinates coordinatesWrapper  coordinatesAligned" ng-bind-html=" coord | bidiCoordinate:x:y "><span class="coordinateX">(-17</span><span class="coordinatePipe">|</span><span class="coordinateY">-46)</span></span>
																									</a>
																									<!-- ngIf: !hasLink -->
																								</span>
																							</td>
																							<td class="population">883</td>
																						</tr>
																						<tr ng-repeat="village in playerData.villages | orderBy:'population':true">
																							<td class="name">
																								<a ng-class="{disabled: villId <= 2 || nolink}" class="villageLink truncated clickable" clickable="$root.openWindow('mapCellDetails', {'cellId': 536756227}, null, true)" village-link="" villageid="536756227" villagename="Coelo">Coelo</a>
																								<!-- ngIf: village.isMainVillage -->
																							</td>
																							<td class="coordinates">
																								<span class="coordinateWrapper" coordinates="" aligned="true" x="3" y="-4">
																									<a ng-if="hasLink" clickable="$root.openPage('map', 'centerId', '536756227_1728243293.4');" class="clickable">
																										<span class="coordinates coordinatesWrapper  coordinatesAligned" ng-bind-html=" coord | bidiCoordinate:x:y "><span class="coordinateX">(3</span><span class="coordinatePipe">|</span><span class="coordinateY">-4)</span></span>
																									</a>
																									<!-- ngIf: !hasLink -->
																								</span>
																							</td>
																							<td class="population">844</td>
																						</tr>
																						<tr ng-repeat="village in playerData.villages | orderBy:'population':true">
																							<td class="name">
																								<a ng-class="{disabled: villId <= 2 || nolink}" class="villageLink truncated clickable" clickable="$root.openWindow('mapCellDetails', {'cellId': 536756214}, null, true)" village-link="" villageid="536756214" villagename="Flammulina">Flammulina</a>
																								<!-- ngIf: village.isMainVillage -->
																							</td>
																							<td class="coordinates">
																								<span class="coordinateWrapper" coordinates="" aligned="true" x="-10" y="-4">
																									<a ng-if="hasLink" clickable="$root.openPage('map', 'centerId', '536756214_1728243293.4');" class="clickable">
																										<span class="coordinates coordinatesWrapper  coordinatesAligned" ng-bind-html=" coord | bidiCoordinate:x:y "><span class="coordinateX">(-10</span><span class="coordinatePipe">|</span><span class="coordinateY">-4)</span></span>
																									</a>
																									<!-- ngIf: !hasLink -->
																								</span>
																							</td>
																							<td class="population">545</td>
																						</tr>
																					</tbody>
																				</table>
																			</div>
																		</div>
																	</div>
																</div>
																<div class="contentBox gradient playerDescription">
																	<div class="contentBoxHeader headerColored">
																		<span translate=""><span>Описание</span></span>
																		<i class="headerButton clickable action_edit_small_flat_black ng-hide" ng-show="canEditDescription" ng-class="{action_edit_small_flat_black: !editHover, action_edit_small_flat_green: editHover}" on-pointer-over="editHover = true" on-pointer-out="editHover = false" clickable="openOverlay('playerProfileEditDescription');" tooltip="" tooltip-translate="Player.EditDescription"></i>
																	</div>
																	<div class="contentBoxBody scrollable" scrollable="">
																		<div class="scrollContentOuterWrapper" style="width: 280px;">
																			<div class="scrollContent" dynamic-height="false" style="width: 280px; overflow-y: hidden;">
																				<div class="scrollContentInnerWrapper" ng-transclude="" style="width: auto;">
																					<div user-text-parse="playerProfile.description" parse="decorations;medals;achievements" class="desc"><span>Migera aka Elfinya</span><br><br><br><br><span>Be Kind</span><br><br><br><br><span>https://www.youtube.com/watch?v=imyK-urU9jI</span></div>
																				</div>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
															<div class="horizontalLine" ng-hide="myPlayerId == playerId"></div>
															<div class="contentWrapper" ng-hide="myPlayerId == playerId">
																<div class="openChat">
																	<button tooltip="" tooltip-translate="Chat.Open" clickable="openChat(getPrivateRoomName(playerData.playerId))" class="clickable">
																		<div class="content">
																			<span ng-transclude="" class="innerText">
																				<span translate=""><span>Открыть чат</span></span>
																			</span>
																			<!-- ngIf: price > 0 || forceGoldUsage -->
																			<!-- ngIf: price == -1 && !forceGoldUsage -->
																			<div class="animationOverlay"></div>
																			<i class="checkmark action_check_small_flat_white"></i>
																			<i class="checkmark action_check_small_flat_black"></i>
																			<i class="checkmark action_check_small_flat_red"></i>
																		</div>
																	</button>
																</div>
																<div class="iconButton beAFriend clickable" ng-class="{disabled: !userAddable(playerData.playerId)}" content="Добавить в друзья" v-tippy="{placement: 'top'}" tooltip-translate-switch="{
																	'Chat.AddFriend': true,
																	'Chat.CantAddFriend': false
																}" clickable="addFriend(playerData.playerId, playerData.name)">
																	<i class="community_playerAdd_small_flat_black"></i>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="window-overlay"></div>
				</div>
			</div>
		</div>
	</vue-final-modal>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';

export default {
	mixins: lib.mixins,
	props: {
		closeable: {
			type: Boolean,
			default: true,
		},
	},
	data: () => ({
		cancelHover: false,
	}),
	computed: {},
	methods: {
		onModalOpen(){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/IWUIS_1.ogg');
				audio.play();
			}
		},
		onModalClose(close){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/IWUIS_2.ogg');
				audio.play();
			}
			if(close) close();
		},
	},
	mounted(){
		this.onModalOpen();
	},
	beforeDestroy(){
		this.onModalClose();
	},
	components: {},
}
</script>